import * as actionTypes from './actionTypes';
import { PaymentPriceModel } from '@app/src/views/StepPayment/formPayment/models/PaymentPriceModel';

interface State {
  data: PaymentPriceModel;
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: {},
  isFetching: false,
  error: false
}

export const pricePackage = (state: State = initialState, action) => {
  switch(action.type) {
    case actionTypes.FETCH_PRICE_PACKAGE_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_PRICE_PACKAGE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_PRICE_PACKAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    default:
      return state;
  }
}
